import $ from "jquery";

const selectors = {
	submitButton: ".js-submit-button",
	registrationForm: ".js-registration-form",
	firstName: ".js-customer-name",
	lastName: ".js-customer-lastName",
	title: ".js-customer-title",
	gender: "input[name='customer[tags][gender]']:checked",
	password: ".js-customer-password",
	email: ".js-customer-email",
	passwordConfirm: ".js-customer-password-confirm",
	statusErrorMessage: "[data-status-error-message]",
	statusSuccessMessage: "[data-status-success-message]"
};

const customerSaveOptions = {
	login: true,
	redirect: true,
	redirectUrl: "/account/"
};

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

function formValidator() {
	let email = $(selectors.email).val(),
		password = $(selectors.password).val(),
		passwordConfirm = $(selectors.passwordConfirm).val(),
		name = $(selectors.firstName).val(),
		lastName = $(selectors.lastName).val(),
		button = $(selectors.submitButton);

	if (email && password && password === passwordConfirm && name && lastName) {
		button.removeAttr("disabled");
	} else {
		button.attr("disabled", true);
	}
}

$(function () {
	if (!$(selectors.registrationForm).length) {
		return;
	}

	$(selectors.email).on("input", formValidator);
	$(selectors.password).on("input", formValidator);
	$(selectors.passwordConfirm).on("input", formValidator);
	$(selectors.firstName).on("input", formValidator);
	$(selectors.lastName).on("input", formValidator);

	$(selectors.submitButton).on("click", function (e) {
		e.preventDefault();

		let form = $(selectors.registrationForm);
		let first_name = $(selectors.firstName).val();
		let last_name = $(selectors.lastName).val();
		let title = $(selectors.title).val();
		let gender = $(selectors.gender).val();
		let password = $(selectors.password).val();
		let email = $(selectors.email);
		let password_confirmation = $(selectors.passwordConfirm);

		if (form[0].checkValidity() && !$.isEmptyObject(window.CF)) {
			$(selectors.submitButton).prop("disabled", true);

			window.CF.customerReady(function () {
				window.CF.customer.set({
					first_name,
					last_name,
					title,
					gender,
					password,
					email: email.val(),
					password_confirmation: password_confirmation.val()
				});

				window.CF.customer
					.save(customerSaveOptions)
					.then(function (errorObj) {
						$(selectors.submitButton).prop("disabled", false);
						if (errorObj) {
							for (const [key, value] of Object.entries(
								errorObj
							)) {
								if (key === "password_confirmation") {
									document.querySelector(
										selectors.statusErrorMessage
									).innerText = `${capitalizeFirstLetter(key)
										.split("_")
										.join(" ")} ${value}`;
								} else {
									document.querySelector(
										selectors.statusErrorMessage
									).innerText = `${capitalizeFirstLetter(
										key
									)} ${value}`;
								}

								document
									.querySelector(selectors.statusErrorMessage)
									.classList.remove("hidden");
							}
						} else {
							document.querySelector(
								selectors.statusSuccessMessage
							).innerText = `An activation email was sent to: ${email.val()}`;
							document
								.querySelector(selectors.statusSuccessMessage)
								.classList.remove("hidden");
						}
					})
					.catch(function (err) {
						console.error("Could not save customer", err);
					});
			});
		} else {
			form[0].reportValidity();
		}
	});
});
